import { createContext, useContext, useState, type ReactNode } from "react";
import type { YjsTransportStatus } from "./types";

// Bridges the Yjs transport's connection status from YjsStoryProvider (which
// owns the transport) up to the reconnect banner in YjsConnectionStatusProvider
// (a parent). Default "connected" + no-op reporter mean the Liveblocks path,
// which never publishes, is unaffected.
const ValueCtx = createContext<YjsTransportStatus>("connected");
const ReportCtx = createContext<(status: YjsTransportStatus) => void>(() => {});

export const useYjsTransportStatus = () => useContext(ValueCtx);
export const useReportYjsTransportStatus = () => useContext(ReportCtx);

export const YjsTransportStatusProvider = ({ children }: { children: ReactNode }) => {
  const [status, setStatus] = useState<YjsTransportStatus>("connected");
  return (
    <ReportCtx.Provider value={setStatus}>
      <ValueCtx.Provider value={status}>{children}</ValueCtx.Provider>
    </ReportCtx.Provider>
  );
};
